import { useMemo } from 'react';

export const usePlainText = (html: string, charLimit: number | undefined = undefined) => {
  return useMemo(() => {
    const node = window.document.createElement('div');
    node.innerHTML = html;
    if (charLimit && node.innerText?.length > charLimit) {
      return node.innerText.slice(0, charLimit) + '...';
    } else {
      return node.innerText;
    }
  }, [html, charLimit]);
};
